/**
 * Values lifted from the Paper file "Bamboo Analytics". The comments carry the
 * design-token name each hex came from, so a change there is traceable here.
 */
export const ANALYTICS = {
  font: '"Nunito Sans", "Helvetica", "Arial", sans-serif',

  ink: '#08081B', // --color-text-primary
  muted: '#63637D', // --color-text-secondary
  disabled: '#7F7F99', // --color-text-disabled
  background: '#F6F6F8', // --color-background
  surface: '#FFFFFF', // --color-surface
  divider: 'rgba(8, 8, 27, 0.15)', // --color-divider
  primary: '#2A2A8B', // --color-primary
  success: '#52BB3A', // --color-success

  grey25: '#F6F6F8', // --color-grey-25
  grey50: '#E3E3E8', // --color-grey-50
  grey100: '#C1C1CD', // --color-grey-100
  grey600: '#3C3C60', // --color-grey-600
  yellow100: '#FFEFC2', // --color-yellow-100
  yellow900: '#4D1C00', // --color-yellow-900
  red100: '#FFBDBD', // --color-red-100
  red600: '#D00101', // --color-red-600
  indigo50: '#EFEFFA', // --color-indigo-50
  indigo700: '#2A2A8B', // --color-indigo-700
  orange50: '#FDEAD8', // --color-orange-50
  orange500: '#FB7B04', // --color-orange-500
  orange800: '#843501', // --color-orange-800
  teal600: '#1FB297', // --color-teal-600
  pink500: '#F70897', // --color-pink-500
  green50: '#F1FAEF', // --color-green-50
  green600: '#42982F', // --color-green-600
  green700: '#317123', // --color-green-700
  actionHover: 'rgba(8, 8, 27, 0.04)', // --color-action-hover
  elevationCard: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)', // --elevation-card

  tracking: { tight: '-0.5px', wider: '1px' },

  /**
   * The four window columns are a fixed block so every row on the page — the
   * activity table and the problems card both — shares one set of lanes.
   */
  lane: { cell: 116, block: 464, gap: 24 },
} as const;
